<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{$ml.get('shared.overtimeDefinitions')}}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get('shared.dashboard')}}</span>
        </li>
        <li>
          <i class="fa fa-book"></i>
          <span>{{$ml.get('shared.definitions')}}</span>
        </li>
        <li>
          <span>{{$ml.get('shared.overtimeDefinitions')}}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-6">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{$ml.get('overtimeDefinitions.overtimePlaces')}}</span>
              </h3>
              <div class="box-tools pull-right">
                <button
                  class="btn btn-sm btn-warning "
                  data-toggle="modal"
                  data-target="#modal-yeni-yer"
                  @click="newOvertimePlace()"
                >
                  <i class="fa fa-plus"></i> {{$ml.get('general.addNew')}}
                </button>
              </div>
            </div>
            <div class="box-body">
              <div
                v-show="overtimePlaceList.length > 0"
                class="table-responsive no-padding"
                :style="windowHeightSize"
              >
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="place in overtimePlaceList" :key="place.id">
                      <td>
                        <span>{{place.name}}</span>
                      </td>
                      <td>
                        <button
                          class="btn btn-primary btn-sm"
                          data-toggle="modal"
                          data-target="#modal-yer-guncelle"
                          @click="selectOvertimePlace(place)"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                        <button
                          class="btn btn-danger btn-sm"
                          data-toggle="modal"
                          data-target="#modal-yer-sil"
                          @click="selectOvertimePlace(place)"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="overtimePlaceList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i> {{$ml.get('overtimeDefinitions.overtimePlaceNotRecord')}}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoadingPlace">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{$ml.get('overtimeDefinitions.overtimeDescriptions')}}</span>
              </h3>
              <div class="box-tools pull-right">
                <button
                  class="btn btn-sm btn-warning "
                  data-toggle="modal"
                  data-target="#modal-yeni-neden"
                  @click="newOvertimeDescription()"
                >
                  <i class="fa fa-plus"></i> {{$ml.get('general.addNew')}}
                </button>
              </div>
            </div>
            <div class="box-body">
              <div
                v-show="overtimeDescriptionList.length > 0"
                class="table-responsive no-padding"
                :style="windowHeightSize"
              >
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="description in overtimeDescriptionList" :key="description.id">
                      <td>
                        <span>{{description.name}}</span>
                      </td>
                      <td>
                        <button
                          class="btn btn-primary btn-sm"
                          data-toggle="modal"
                          data-target="#modal-neden-guncelle"
                          @click="selectOvertimeDescription(description)"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                        <button
                          class="btn btn-danger btn-sm"
                          data-toggle="modal"
                          data-target="#modal-neden-sil"
                          @click="selectOvertimeDescription(description)"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="overtimeDescriptionList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i> {{$ml.get('overtimeDefinitions.overtimeDescriptionNotRecord')}}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoadingDescription">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL START-->
      <div class="modal modal-success fade" id="modal-yeni-yer">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('overtimeDefinitions.newOvertimePlaceDefinition')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <span>{{$ml.get('overtimeDefinitions.overtimePlaceName')}}</span>
                <input type="text" class="form-control" v-model="overtimePlace.name" />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="saveOvertimePlace()" class="btn btn-success" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{$ml.get('general.save')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-primary fade" id="modal-yer-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('overtimeDefinitions.overtimePlaceUpdate')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <span>{{$ml.get('overtimeDefinitions.overtimePlaceName')}}</span>
                <input type="text" class="form-control" v-model="overtimePlace.newName" />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="updateOvertimePlace()" class="btn btn-success" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{$ml.get('general.update')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="modal-yer-sil">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.delete')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{overtimePlace.name}}</span>
              </div>
              <br />
              <p></p>
              <span>{{$ml.get('overtimeDefinitions.isContinueOvertimePlaceDelete')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="deleteOvertimePlace()" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-trash"></i>
                <span>{{$ml.get('general.delete')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-success fade" id="modal-yeni-neden">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('overtimeDefinitions.newOvertimeDescriptionDefinition')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <span>{{$ml.get('overtimeDefinitions.overtimeDescriptionName')}}</span>
                <input type="text" class="form-control" v-model="overtimeDescription.name" />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button
                @click="saveOvertimeDescription()"
                class="btn btn-success"
                data-dismiss="modal"
              >
                <i class="fa fa-check"></i>
                <span>{{$ml.get('general.save')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-primary fade" id="modal-neden-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('overtimeDefinitions.overtimeDescriptionUpdate')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <span>{{$ml.get('overtimeDefinitions.overtimeDescriptionName')}}</span>
                <input type="text" class="form-control" v-model="overtimeDescription.newName" />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button
                @click="updateOvertimeDescription()"
                class="btn btn-success"
                data-dismiss="modal"
              >
                <i class="fa fa-check"></i>
                <span>{{$ml.get('general.update')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="modal-neden-sil">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.delete')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{overtimeDescription.name}}</span>
              </div>
              <br />
              <p></p>
              <span>{{$ml.get('overtimeDefinitions.isContinueOvertimeDescriptionDelete')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button
                @click="deleteOvertimeDescription()"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                <i class="fa fa-trash"></i>
                <span>{{$ml.get('general.delete')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoadingDescription: false,
      isLoadingPlace: false,
      overtimeDescription: {
        id: null,
        name: "",
        newName: ""
      },
      overtimePlace: {
        id: null,
        name: "",
        newName: ""
      },
      overtimeDescriptions: [],
      overtimePlaces: []
    };
  },
  computed: {
    authControl(){
      return this.$store.getters.getAuthTanimlamalar;
    },
    overtimeDescriptionList() {
      return this.overtimeDescriptions;
    },
    overtimePlaceList() {
      return this.overtimePlaces;
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    selectOvertimePlace(place) {
      this.overtimePlace.id = place.id;
      this.overtimePlace.name = place.name;
      this.overtimePlace.newName = place.name;
    },
    selectOvertimeDescription(description) {
      this.overtimeDescription.id = description.id;
      this.overtimeDescription.name = description.name;
      this.overtimeDescription.newName = description.name;
    },
    newOvertimePlace() {
      this.overtimePlace.id = null;
      this.overtimePlace.name = "";
      this.overtimePlace.newName = "";
    },
    newOvertimeDescription() {
      this.overtimeDescription.id = null;
      this.overtimeDescription.name = "";
      this.overtimeDescription.newName = "";
    },
    async deleteOvertimePlace() {
      if (this.overtimePlace.id == null) {
        alertify.warning(this.$ml.get('alerts.pleaseSelect'));
        return;
      }
      try {
        this.isLoadingPlace = true;
        const response = await this.$axios
          .delete("/OvertimePlaces/" + this.overtimePlace.id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingPlace = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingPlace = false;
                return;
              }
            }
          });
        this.newOvertimePlace();
        this.getOvertimePlaces();
        alertify.success(this.$ml.get('alerts.deletedSuccessfully'));
        this.isLoadingPlace = false;
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
        this.isLoadingPlace = false;
      }
    },
    async deleteOvertimeDescription() {
      if (this.overtimeDescription.id == null) {
        alertify.warning(this.$ml.get('alerts.pleaseSelect'));
        return;
      }
      try {
        this.isLoadingDescription = true;
        const response = await this.$axios
          .delete("/OvertimeDescription/" + this.overtimeDescription.id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingDescription = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDescription = false;
                return;
              }
            }
          });
        this.newOvertimeDescription();
        this.getOvertimeDescriptions();
        alertify.success(this.$ml.get('alerts.deletedSuccessfully'));
        this.isLoadingDescription = false;
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
        this.isLoadingDescription = false;
      }
    },
    async saveOvertimePlace() {
      if (this.overtimePlace.name == "") {
        alertify.warning(this.$ml.get('alerts.pleaseEnterAName'));
        return;
      }
      try {
        this.isLoadingPlace = true;
        await this.$axios
          .post("/OvertimePlaces", {
            name: this.overtimePlace.name
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get('alerts.savedSuccessfully'));
              this.isLoadingPlace = false;
              this.getOvertimePlaces();
            } else {
              alertify.error(response.message);
              this.isLoadingPlace = false;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingPlace = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingPlace = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingPlace = false;
      }
    },
    async saveOvertimeDescription() {
      if (this.overtimeDescription.name == "") {
        alertify.warning(this.$ml.get('alerts.pleaseEnterAName'));
        return;
      }
      try {
        this.isLoadingDescription = true;
        await this.$axios
          .post("/OvertimeDescription", {
            name: this.overtimeDescription.name
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get('alerts.savedSuccessfully'));
              this.isLoadingDescription = false;
              this.getOvertimeDescriptions();
            } else {
              alertify.error(response.message);
              this.isLoadingDescription = false;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingDescription = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDescription = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDescription = false;
      }
    },
    async updateOvertimePlace() {
      if (this.overtimePlace.newName == "") {
        alertify.warning(this.$ml.get('alerts.pleaseEnterAName'));
        return;
      }
      try {
        this.isLoadingPlace = true;
        await this.$axios
          .post("/OvertimePlaces/" + this.overtimePlace.id, {
            name: this.overtimePlace.newName
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get('alerts.updatedSuccessfully'));
              this.isLoadingPlace = false;
              this.getOvertimePlaces();
            } else {
              alertify.error(response.message);
              this.isLoadingPlace = false;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingPlace = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingPlace = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingPlace = false;
      }
    },
    async updateOvertimeDescription() {
      if (this.overtimeDescription.newName == "") {
        alertify.warning(this.$ml.get('alerts.pleaseEnterName'));
        return;
      }
      try {
        this.isLoadingDescription = true;
        await this.$axios
          .post("/OvertimeDescription/" + this.overtimeDescription.id, {
            name: this.overtimeDescription.newName
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get('alerts.updatedSuccessfully'));
              this.isLoadingDescription = false;
              this.getOvertimeDescriptions();
            } else {
              alertify.error(response.message);
              this.isLoadingDescription = false;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingDescription = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDescription = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDescription = false;
      }
    },
    async getOvertimeDescriptions() {
      try {
        this.isLoadingDescription = true;
        const overtimeDescriptions = [];
        const response = await this.$axios
          .get("/OvertimeDescription")
          .then(response => {
            response.data.forEach(doc => {
              overtimeDescriptions.push({
                id: doc.id,
                name: doc.name
              });
            });
            this.isLoadingDescription = false;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingDescription = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDescription = false;
                return;
              }
            }
          });
        this.overtimeDescriptions = overtimeDescriptions;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingDescription = false;
      }
    },
    async getOvertimePlaces() {
      try {
        this.isLoadingPlace = true;
        const overtimePlaces = [];
        const response = await this.$axios
          .get("/OvertimePlaces")
          .then(response => {
            response.data.forEach(doc => {
              overtimePlaces.push({
                id: doc.id,
                name: doc.name
              });
            });
            this.isLoadingPlace = false;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingPlace = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingPlace = false;
                return;
              }
            }
          });
        this.overtimePlaces = overtimePlaces;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingPlace = false;
      }
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(
          this.$ml.get('alerts.youAreOnlyAuthorizedToViewThisPage')
        );
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getOvertimeDescriptions();
    await this.getOvertimePlaces();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/overtimeSettings/OvertimeSettings.vue